import * as url from "../url.helper";

import { post } from "../api.helper";

export const callAddWorkflow = data => post(url.ADD_WORKFLOW, data);

export const callGetAllWorkflow = data => post(url.GET_WORKFLOW, data);

export const callGetOneWorkflow = data => post(url.GET_WORKFLOW_BY_ID, data);

export const callEditWorkflow = data => post(url.UPDATE_WORKFLOW, data);

export const callDeleteWorkflow = data => post(url.DELETE_WORKFLOW, data);




